import { render, staticRenderFns } from "./productMixReport.vue?vue&type=template&id=678c2f9e&scoped=true&"
import script from "./productMixReport.vue?vue&type=script&lang=js&"
export * from "./productMixReport.vue?vue&type=script&lang=js&"
import style0 from "./productMixReport.vue?vue&type=style&index=0&id=678c2f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c2f9e",
  null
  
)

export default component.exports